import { computed, effect, Injectable, signal } from '@angular/core';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { PermissionAction, PermissionSubject } from '../../models/permissions';
import { UserService } from '../../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  public allMenuItems: (Omit<MenuItem, 'items'> & {
    moduleName: PermissionSubject | null;
    tooltipLabel: string;
  })[] = [
    {
      label: 'Track',
      icon: PrimeIcons.CLOCK,
      routerLink: 'app/track',
      moduleName: PermissionSubject.TimeEntry,
      tooltipLabel: 'Track',
    },
    {
      label: 'Dashboard',
      icon: PrimeIcons.TH_LARGE,
      routerLink: 'app/dashboard',
      moduleName: PermissionSubject.Dashboard,
      tooltipLabel: 'Dashboard',
    },
    {
      label: 'My Team',
      icon: PrimeIcons.USERS,
      routerLink: 'app/my-team',
      moduleName: PermissionSubject.MyTeam,
      tooltipLabel: 'My Team',
    },
    {
      label: 'Reports',
      icon: PrimeIcons.CHART_LINE,
      routerLink: 'app/reports',
      moduleName: PermissionSubject.Report,
      tooltipLabel: 'Reports',
    },
    {
      label: 'Clients',
      icon: PrimeIcons.BRIEFCASE,
      routerLink: 'app/clients',
      moduleName: PermissionSubject.Client,
      tooltipLabel: 'Clients',
    },
    {
      label: 'Projects',
      icon: PrimeIcons.BOOK,
      routerLink: 'app/projects',
      moduleName: PermissionSubject.Project,
      tooltipLabel: 'Projects',
    },
    {
      label: 'Task Types',
      icon: PrimeIcons.TAGS,
      routerLink: 'app/tasktypes',
      moduleName: PermissionSubject.TaskType,
      tooltipLabel: 'Task Types',
    },
    {
      label: 'Access Role Task Mapping',
      icon: PrimeIcons.ADDRESS_BOOK,
      routerLink: 'app/roletypes',
      moduleName: PermissionSubject.RoleTaskAssignment,
      tooltipLabel: 'Access Role Task Mapping',
    },
    {
      label: 'User Management',
      icon: PrimeIcons.USER,
      routerLink: 'app/team',
      moduleName: PermissionSubject.UserManagement,
      tooltipLabel: 'Team',
    },
    {
      label: 'Settings',
      icon: PrimeIcons.COG,
      routerLink: 'app/settings',
      moduleName: null,
      tooltipLabel: 'Settings',
    },
    {
      label: 'Superset',
      icon: PrimeIcons.CHART_PIE,
      routerLink: 'app/superset',
      moduleName: PermissionSubject.SupersetReport,
      tooltipLabel: 'Superset',
    },
  ];

  private _menuItems = signal<MenuItem[]>([]);
  public menuItems = computed(() => this._menuItems());

  public visible = signal(false);
  selectedMenu: any;

  constructor(private userService: UserService) {
    effect(() => {
      if (this.userService.isAbilityReady()) {
        // const isManager =
        //   this.userService.userDetails()?.isReportingManager ?? false;
        const filtered = this.allMenuItems
          .filter((item) => {
            // if (item.tooltipLabel === 'My Team') {
            //   return isManager;
            // }
            return this.userService.hasPermission(
              item.moduleName!,
              PermissionAction.View,
            );
          })
          .map(
            (item): MenuItem => ({
              ...item,
              visible: true,
              disabled: false,
              tooltipOptions: {
                tooltipLabel: item.tooltipLabel,
              },
            }),
          );
        // Remove "My Team" if not manager
        // if (!isManager) {
        //   filtered = filtered.filter((item) => item.label !== 'My Team');
        // }

        this._menuItems.set(filtered);
      }
    });
  }

  open() {
    this.visible.set(true);
  }

  close() {
    this.visible.set(false);
  }

  toggle() {
    this.visible.update((current) => !current);
  }
}
